import { useTranslation } from 'react-i18next';

import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { OrgMemberPicker } from '@/features/org/components/org-member-picker/org-member-picker';
import {
  FlowBackButton,
  FlowSubmitButton,
} from '@/shared/components/flow/flow-actions';
import { FlowHeaderOptional } from '@/shared/components/flow/flow-fields';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';

export interface CreateProjectInvitationInputFormProps {
  onSuccess: (memberId: string) => void;
  onSkip: () => void;
  memberIdsToInvite: string[];
  onBack: () => void;
  orgMembers: OrgMemberWithProfile[];
}

export const CreateProjectInvitationInputForm = ({
  onSuccess,
  onSkip,
  memberIdsToInvite,
  orgMembers,
  onBack,
}: CreateProjectInvitationInputFormProps) => {
  const { t } = useTranslation('project', { keyPrefix: 'InviteUsersForm' });
  const { t: shared_t } = useTranslation('project', {
    keyPrefix: 'Shared',
  });

  return (
    <Card variant="form" wrapWithStars>
      <CardHeader>
        <FlowHeaderOptional />
        <CardTitle>{t('title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <OrgMemberPicker
          orgMembers={
            orgMembers?.map((orgMember) => ({
              ...orgMember,
              profile: orgMember.profile,
            })) || []
          }
          existingInvitations={memberIdsToInvite}
          onSuccess={onSuccess}
          onlyMemberRole={true}
        />
      </CardContent>
      <CardFooter>
        <FlowBackButton onClick={onBack}>
          {shared_t('back_button_label')}
        </FlowBackButton>
        <FlowSubmitButton onClick={onSkip}>
          {t('continue_button')}
        </FlowSubmitButton>
      </CardFooter>
    </Card>
  );
};
